module.exports = __webpack_public_path__ + "img/logo-light.5837ed18.svg";